<template>
	<div class="page-content">
		<FixedTool />
		<div class="banner"><img style="width:100%;height:100%;" src="../../assets/images/jlxq.gif"></div>

		<!-- 头部信息 -->
		<div class="banner">
			<div class="coach-info">
				<img :src="coachDetail.head_pic" alt="" class="head">
				<div class="info">
					<div class="name">
						<span>{{coachDetail.nickname}}</span>
						<img v-show="coachDetail.is_own_shop == 1" src="../../assets/images/vip-gold.png" alt="" class="v">
						<img v-show="Number(coachDetail.reward_gift) >= Number(coachDetail.coach_red_open_price)"  src="../../assets/images/hot-f.png" alt="" class="h">
					</div>
					<div class="desc">教龄：{{coachDetail.level_category}}年 | 学员：{{coachDetail.fake_consult_count}}人</div>
					<div class="tags" v-if="coachTags.length > 0">
						<div class="tag" v-for="item in coachTags" :key="item.id">{{item.name}}</div>
					</div>
				</div>
			</div>
			<!-- tab选项卡 -->
			<div class="tabs">
				<div :class="{'active': tabIndex == 1}" @click="switchTab(1)">教练详情</div>
				<div :class="{'active': tabIndex == 2}" @click="switchTab(2)">金牌打赏人</div>
			</div>
		</div>
		<div class="tab-content">
			<!-- 教练详情 -->
			<div class="coach-detail" v-if="tabIndex == 1">
				<div class="d-list">
					<img src="../../assets/images/icon_address_blue.png" alt="" class="address-icon">
					<span class="info">
						<div class="name">{{coachDetail.store_name}}</div>
						<div class="address">{{coachDetail.province_id_name}}{{coachDetail.city_id_name}}{{coachDetail.district_name}}{{coachDetail.street_id_name}}</div>
					</span>
<!--					<span class="distance" @click="$router.push({name:'StDetail',query:{id:coachDetail.store_id}})">去驾校</span>-->
					<span class="distance"@click="$router.push({name:'map',query:{address:coachDetail.province_id_name + coachDetail.city_id_name + coachDetail.district_name + coachDetail.street_id_name}})">去驾校</span>
					<img src="../../assets/images/icon_right.png" alt="" class="right-icon">
				</div>
				<div class="d-list exceptional">
					<img src="../../assets/images/icon_gift.png" alt="" class="address-icon">
					<span class="info">
						<div class="name">已收到{{coachDetail.num}}个礼物</div>
						<div class="address">收到的打赏越多，受欢迎程度越高哦~</div>
					</span>
					<span class="distance" @click="handleClick">去打赏</span>
					<img src="../../assets/images/icon_right.png" alt="" class="right-icon">
				</div>
				<!-- 优惠券 -->
				<div class="st-coupons" v-if="coachCoupons && coachCoupons.length > 0">
					<nut-scroller>
					    <div slot="list" v-for="(item, index) of coachCoupons" :key="index">
					        <div class="coupons-item-info">
					            <Coupons :coupons-data="item" :isClick="true" :coupons-tab="1"  @getCoupon="getCoupon"></Coupons>
					        </div>
					    </div>
					</nut-scroller>
				</div>
				<!-- 班型列表 -->
				<div class="plate-title" v-show="classList.length > 0">
					<span class="title" style="margin-left: 10px;">所有班型</span>
					<span class="all" @click="routerToAllClassType(coachDetail.store_id)">全部{{coachDetail.all_class_count}}个班型</span>
					<img src="../../assets/images/icon_right.png" alt="" style="margin-right:14px;">
				</div>
				<div class="class-type-lists" v-show="classList.length > 0" v-for="(item, index) in classList" :key="index">
					<div class="type-list" v-if="item.class_type == 1">
						<div class="left">
							<div class="top">
								<span class="name">{{item.cat_id1_name}} {{item.title}}</span>
								<div class="type">拼团</div>
							</div>
							<div class="bot">
								<span class="single-price">单购价：￥{{item.shop_price}}</span>
								<span class="group-price">{{item.team_user_count}}人团：￥{{item.group_price}}</span>
							</div>
						</div>
						<div class="right">
							<div class="join-btn" @click="routerToClassTypeDetail(item.id)"  >参与</div>
						</div>
					</div>
					<div class="type-list" v-else>
						<div class="left">
							<div class="top">
								<span class="name">{{item.cat_id1_name}} {{item.goods_name}}</span>
								<span class="price">￥{{item.shop_price}}</span>
							</div>
							<div class="bot">
								<span class="desc">拿本时长{{item.time_long}}天 {{item.cat_id4_name}} {{item.cat_id2_name}}</span>
							</div>
						</div>
						<div class="right">
							<div class="sign-up-btn" @click="routerToClassDetail(item.goods_id)" >报名</div>
						</div>
					</div>
				</div>
				<!-- 简介 -->
				<div class="introduction" v-if="coachDetail.introduce_org">
					<div class="introduction-title">简介</div>
					<div class="content" v-html="'<style>.content *{max-width:100%!important;white-space:unset!important;word-break:break-all!important;height: auto!important;}</style>'+coachDetail.introduce">{{coachDetail.introduce}}</div>
				</div>
			</div>
			<!-- 金牌打赏人 -->
			<div class="exceptional-p-r" v-if="tabIndex == 2">
				<div class="rank-lists" v-if="rewardList.length > 0">
					<div class="rank-list" v-for="(item, index) in rewardList" :key="item.id">
						<div class="rank-number">
							<img src="../../assets/images/huiyuan-0.png" alt="" v-if="index==0">
							<img src="../../assets/images/huiyuan-1.png" alt="" v-if="index==1">
							<img src="../../assets/images/huiyuan-2.png" alt="" v-if="index==2">
							<div v-if="index>2">{{index + 1}}</div>
						</div>
						<img :src=item.head_pic alt="" class="exceptional-head">
						<div class="info" style="border-bottom: 1px solid rgb(220, 220, 220);
						padding-top: 13px;
						padding-bottom: 15px;
						width: 73%;">
							<div class="name">{{item.nickname}}</div>
							<div class="gifts">已送给教练{{item.count}}个礼物</div>
						</div>
					</div>
				</div>
				<div v-else>
					<empty></empty>
				</div>
			</div>
		</div>
		<!-- 底部操作按钮以及礼物提示 -->
		<div class="footer">
			<div class="gift-barrage" v-if="tabIndex == 1 && coachDetail.gift_order">
				<div class="gift">
					<img :src="coachDetail.gift_order.original_img" alt="">
					<span>学员{{coachDetail.gift_order.mobile}}送给{{coachDetail.nickname}}{{coachDetail.gift_order.goods_num}}个{{coachDetail.gift_order.goods_name}}</span>
				</div>
			</div>
			<div class="operation">
				<div class="btn" @click="handleClick">去打赏</div>
			</div>
		</div>
		<!-- 选择优惠券弹窗 -->
		<nut-popup position="bottom" closeable close-icon="cross" v-model="couponsPopupShow" :style="{ height: '403px' }" :overlay="true" class="coupons-popup-content">
			<div class="popup-title">领取优惠券</div>
			<div class="coupons">
				<nut-scroller>
				    <div slot="list">
				        <div class="coupons-item-info" v-for="(item, index) in coachCoupons" :key="index">
							    <Coupons :width="'100%'" :height="'100%'" :coupons-data="item" :coupons-tab="2" :isClick="false"></Coupons>
					    </div>
				    </div>
				</nut-scroller>
			</div>
			<div class="rules">
				<div class="rules-title">
					<div class="left-line"></div>
					<span>使用规则</span>
					<div class="right-line"></div>
				</div>
				<div class="rules-content" v-if="couponsData" v-html="couponsData.rule">

				</div>
			</div>
			<div class="opration">
				<div class="st-o" v-if="couponsData.price>0">
					<div class="money">实付：<span style="color:#EB273B;">￥{{couponsData.price}}元</span></div>
					<div class="btn" @click="addOrder">立即购买</div>
				</div>
				<div class="plat-o" v-else>
					<div class="btn" @click="formPopupShow=true">立即领取</div>
					<div class="prompt">领取优惠券后，驾校/教练将会与你电话联系</div>
				</div>
			</div>
		</nut-popup>
		<!-- 免费领取信息流弹窗 -->
		<nut-popup position="bottom" v-model="formPopupShow" :style="{ height: '497px' }" :overlay="true" class="info-popup-content">
			<div class="popup-title">
				<!-- <img src="../../assets/images/icon_left.png" alt="" @click="closeInfoPopup"> -->
				留下你的信息，驾校将会与你联系
			</div>
			<div class="myform">
				<FreeForm :isSubmit="submitForm"  :freeformsubmitsuccess="freeformsubmitsuccess" :couponid="couponsData.id" source="coupon" :storeid="store_id" @getFormData="getFormData" ref="freeform"></FreeForm>
			</div>
			<div class="opration">
				<div class="btn" @click="helpFindDriving">提交</div>
				<div class="prompt">领取优惠券后，驾校/教练将会与你电话联系</div>
			</div>
		</nut-popup>
	</div>
</template>

<script>
import Coupons from '@/components/Coupons'
import FreeForm from '@/components/FreeForm'
import empty from '@/views/Empty'
export default {
	name: 'AllCoach',
	components: {Coupons, FreeForm},
	data() {
		return {
			store_id: 0,
			coach_id: '',
			coachDetail: Object,
			coachTags: [],  //教练标签
			coachCoupons: [],   //教练所属驾校优惠券
			classList: [],   //教练所属驾校的班型
			tabIndex: 1, //当前tab下标
			rewardList: [],  //当前教练用户打赏排行榜
			couponsData: {}, //优惠券数据
			couponsPopupShow: false, //显示优惠券弹窗
			formPopupShow: false, //显示免费领取信息流弹窗
			submitForm: false, //是否提交表单
      		exceptionalPeople: [{
      			id: 1,
      			ranking: 1,
      			headUrl: require('../../assets/images/m_photo.png'),
      			name: '秋冬',
      			giftNumber: 1120
      		}, {
      			id: 2,
      			ranking: 2,
      			headUrl: require('../../assets/images/m_photo.png'),
      			name: '秋冬',
      			giftNumber: 524
      		}, {
      			id: 3,
      			ranking: 3,
      			headUrl: require('../../assets/images/m_photo.png'),
      			name: '秋冬',
      			giftNumber: 120
      		}, {
      			id: 4,
      			ranking: 4,
      			headUrl: require('../../assets/images/m_photo.png'),
      			name: '秋冬',
      			giftNumber: 110
      		}, {
      			id: 5,
      			ranking: 5,
      			headUrl: require('../../assets/images/m_photo.png'),
      			name: '秋冬',
      			giftNumber: 90
      		}]
    	}
	},
	created() {
		document.title = '教练详情';
	},
	methods: {
		getCoupon(coupon){
			this.couponsPopupShow = true;
			this.couponsData = coupon ;
		},
		//提交成功
		freeformsubmitsuccess(){
			this.couponsPopupShow = false;
			this.formPopupShow = false;
		},
		// 表单组件验证通过回调
		getFormData(data) {

		},
		// 提交表单
		helpFindDriving() {
			this.submitForm = !this.submitForm;
			this.$refs.freeform.submit();
		},
		addOrder(){
			this.$ajax.get('m/order/add_order', {
				activity_id: this.$ajax.get_activity_id(),
				coupon_id: this.couponsData.id,
				order_prom_type: 1223,
				num: 1
			}).then(order_id => {
				this.$router.push({name: 'SureOrder', query: {order_id: order_id}});
			})
		},
		/**
		 * 切换tab选项卡
		 * @param {number} index - 下标
		 */
		switchTab(index) {
			this.tabIndex = index;
		},
		getCoach(coach_id) {
			this.$ajax.get('m/getlist/adviser_detail', {'activity_id': this.$ajax.get_activity_id(), 'id': this.coach_id}).then(res => {
				document.title = '教练详情';
				this.coachDetail = res;
				this.coachTags = res.tags;
				this.coachCoupons = res.coupons;
				this.classList = res.class;
				this.shareDiyRead(res.share);
			});
		},
		getRewardList(coach_id) {
			this.$ajax.get('m/getlist/rewardList', {'activity_id': this.$ajax.get_activity_id(), 'coach_id': coach_id}).then(res => {
				this.rewardList = res;
			});
		},
		shareDiyRead(data){
				console.log(data)
            	if(data.img){
					window.shareConf.fx_pic = data.img;
				}
				if(data.title){
					window.shareConf.fx_title = data.title;
				}
				if(data.desc){
					window.shareConf.fx_memo = data.desc
				}

				window.shareConf.fx_url = data.url;
				console.log(window.shareConf)
				shareDiy();
			},
		handleClick() {
			var data = {};
			data.head_pic = this.coachDetail.head_pic;
			data.nickname = this.coachDetail.nickname;
			data.num = this.coachDetail.num;
			data.id = this.coachDetail.id;
			// console.log(this.coachDetail)
			this.$router.push({ name: 'Reward', query: data})
		},
		/**
		 * 跳转普通班型详情
		 * @param {number} id - 普通班型id
		 */
		routerToClassDetail(id) {
			this.$router.push({name: 'ClassDetail', query: {class_id: id}});
		},
		/**
		 * 跳转拼团班型详情
		 * @param {number} id - 拼团班型id
		 */
		routerToClassTypeDetail(id) {
			this.$router.push({ name: 'ClassTypeDetail', query: { team_detail_id: id }});
		},
		/**
		 * 跳转全部班型
		 * @param {number} id - 驾校id
		 */
		routerToAllClassType(store_id) {
			this.$router.push({ name: 'AllClassType', query: { store_id: store_id }});
		},
	},
	mounted() {
		document.title = '教练详情';
		this.coach_id = this.$route.query.coach_id;
		this.getCoach(this.$route.query.coach_id);
		this.getRewardList(this.$route.query.coach_id);
	},
}
</script>

<style lang="less" scoped>
	.page-content {
		width: 100%;
    padding-bottom: 94px;
		.banner {
			width: 100%;
			.coach-info {
				width: 100%;
				box-sizing: border-box;
				padding: 20px 15px 10px;
				display: flex;
				.head {
					width: 60px;
					height: 60px;
					object-fit: cover;
					border-radius: 50%;
					margin-right: 10px;
				}
				.info {
					width: 60%;
					flex: 1;
					.name {
						display: flex;
						align-items: center;
						span {
							font-size: 16px;
							font-weight: bold;
							color: #333;
						}
						.v {
							width: 14px;
							height: 14px;
							margin-left: 5px;
						}
						.h {
							width: 24px;
							height: 14px;
							margin-left: 5px;
						}
					}
					.desc {
						margin-top: 5px;
						font-size: 12px;
						color: #666;
					}
					.tags {
						width: 100%;
						display: flex;
						align-items: center;
						margin-top: 10px;
						.tag {
							height: 20px;
							line-height: 20px;
							box-sizing: border-box;
							padding: 0 5px;
							background-color: #FFDCE8;
							border-radius: 3px;
							margin-top: 5px;
							margin-right: 10px;
							font-size: 12px;
							color: #FF518C;
						}
						.tag:nth-child(2) {
							background-color: #D8D9FB;
							color: #3C43EC;
						}
						.tag:nth-child(3) {
							background-color: #FFE6CD;
							color: #FF8306;
						}
					}
				}
			}
			.tabs {
				width: 100%;
				height: 40px;
				border-bottom: 1px #E2E2E2 solid;
				display: flex;
				div {
					width: 50%;
					height: 100%;
					line-height: 40px;
					text-align: center;
					font-size: 16px;
					color: #999;
				}
				.active {
					font-weight: bold;
					color: #333;
					border-bottom: 2px #3C43EC solid;
				}
			}
		}
		.tab-content {
			width: 100%;
			.coach-detail {
				width: 100%;
				box-sizing: border-box;
				.d-list {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-top: 15px;
					box-sizing: border-box;
					padding: 0 15px;
					.address-icon {
						margin-right: 10px;
					}
					.info {
						width: 50%;
						flex: 1;
						margin-right: 5px;
						.name {
							font-size: 14px;
							color: #333;
						}
						.address {
							font-size: 12px;
							color: #999;
							margin-top: 5px
						}
					}
					.distance {
						font-size: 12px;
						color: #999;
						margin-right: 5px;
					}
				}
				.plate-title {
					margin-top: 15px;
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.title {
						font-size: 15px;
						font-weight: bold;
						color: #333;
						flex: 1;
					}
					.all {
						font-size: 12px;
						color: #999;
						margin-right: 5px;
					}
				}
				.exceptional {
					margin-top: 20px;
				}
				.st-coupons {
					width: 100%;
					box-sizing: border-box;
					padding-left: 15px;
					margin-top: 20px;
					.coupons-item-info {
						margin-right: 10px;
					}
				}
				.class-type-lists {
					width: 100%;
					box-sizing: border-box;
					padding: 0 15px;
					.type-list {
						margin-top: 20px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						.left {
							width: 50%;
							flex: 1;
							.top {
								width: 100%;
								display: flex;
								align-items: center;
								.name {
									font-size: 15px;
									color: #333;
									margin-right: 5px;
								}
								.type {
									width: 32px;
									height: 18px;
									background-color: #FF808E;
									border-radius: 3px;
									font-size: 12px;
									color: #fff;
									text-align: center;
									line-height: 18px;
								}
								.price {
									font-size: 18px;
									color: #EB273B;
								}
							}
							.bot {
								width: 100%;
								display: flex;
								align-items: center;
								margin-top: 10px;
								.single-price {
									font-size: 13px;
									color: #666;
									margin-right: 10px;
								}
								.group-price {
									font-size: 14px;
									color: #EB273B;
								}
								.desc {
									font-size: 12px;
									color: #999;
								}
							}
						}
						.right {
							div {
								width: 60px;
								height: 28px;
								line-height: 28px;
								text-align: center;
								border-radius: 15px;
								font-size: 12px;
							}
							.join-btn {
								border: 1px #3C43EC solid;
								color: #3C43EC;
							}
							.sign-up-btn {
								border: 1px #EB273B solid;
								color: #EB273B;
							}
						}
					}
				}
				.introduction {
					width: 100%;
					margin-bottom: 10px;
					margin-top: 18px;
					.introduction-title {
						width: 100%;
						height: 40px;
						line-height: 40px;
						box-sizing: border-box;
						padding: 0 15px;
						font-size: 15px;
						font-weight: bold;
						color: #333;
						border-bottom: 1px #E2E2E2 solid;
					}
					.content {
						::v-deep{
							img{width: 100%;}
						}
						width: 100%;
						box-sizing: border-box;
						padding: 10px 15px;
						font-size: 13px;
						color: #999;
						line-height: 20px;
					}
				}
			}
			.exceptional-p-r {
				width: 100%;
				.rank-lists {
					width: 100%;
					box-sizing: border-box;
					padding: 0 15px;
					.rank-list {
						width: 100%;
						height: 73px;
						display: flex;
						align-items: center;
						.rank-number {
							width: 20px;
							height: 16px;
							margin-right: 10px;
							div {
								font-size: 16px;
								font-weight: bold;
								color: #333;
								line-height: 16px;
								text-align: center;
							}
							img {
								width: 100%;
							}
						}
						.exceptional-head {
							width: 44px;
							height: 44px;
							border-radius: 50%;
							margin-right: 10px;
						}
						.info {
							.name {
								font-size: 15px;
								font-weight: bold;
								color: #333;
							}
							.gifts {
								font-size: 13px;
								color: #666;
								margin-top: 10px;
							}
						}
					}
				}
			}
		}
		.footer {
			width: 100%;
			position: fixed;
			bottom: 0;
			left: 0;
			.gift-barrage {
				width: 100%;
				height: 24px;
				display: flex;
				justify-content: flex-end;
				box-sizing: border-box;
				padding: 0 15px;
				.gift {
					height: 24px;
					box-sizing: border-box;
					padding: 0 10px;
					display: flex;
					align-items: center;
					background:rgb(239, 238, 238);
					border-radius: 14px;
					font-size: 12px;
					color: #333;
					img {
						margin-right: 5px;
            height: 25px;
					}
				}
			}
			.operation {
				width: 100%;
				height: 60px;
				box-sizing: border-box;
				padding: 10px 15px;
				background-color: #fff;
				border-top: 1px #E2E2E2 solid;
				.btn {
					width: 100%;
					height: 100%;
					line-height: 40px;
					text-align: center;
					background: linear-gradient(45deg,rgba(255,96,57,1) 0%,rgba(255,176,91,1) 100%);
					border-radius: 25px;
					font-size: 15px;
					font-weight: bold;
					color: #fff;
				}
			}
		}
		.coupons-popup-content {
			.popup-title {
				width: 100%;
				text-align: center;
				font-size: 15px;
				font-weight: bold;
				color: #333;
				margin-top: 15px;
			}
			.coupons {
				width: 100%;
				height: 80px;
				box-sizing: border-box;
				padding-left: 15px;
				margin-top: 20px;
				.coupons-item-info {
					width: 277px;
					height: 100%;
					margin-right: 15px;
				}
			}
			.rules {
				width: 100%;
				box-sizing: border-box;
				padding: 0 15px;
				margin-top: 20px;
				.rules-title {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					.left-line {
						width: 48px;
						height: 1px;
						background: linear-gradient(270deg,rgba(51,51,51,1) 0%,rgba(255,255,255,0) 100%);
					}
					span {
						font-size: 15px;
						color: #333;
						margin: 0 20px;
					}
					.right-line {
						width: 48px;
						height: 1px;
						background: linear-gradient(90deg,rgba(51,51,51,1) 0%,rgba(255,255,255,0) 100%);
					}
				}
				.rules-content {
					::v-deep{
						img{width: 100%;}
					}
					width: 100%;
					height: 110px;
					margin-top: 10px;
					font-size: 13px;
					color: #666;
					line-height: 20px;
					overflow-y: scroll;
				}
			}
			.opration {
				width: 100%;
				box-sizing: border-box;
				padding: 0 15px;
				margin-top: 20px;
				.st-o {
					.money {
						width: 100%;
						text-align: center;
						font-size: 14px;
						color: #666;
						span {
							color: #EB273B;
						}
					}
					.btn {
						width: 100%;
						height: 40px;
						line-height: 40px;
						text-align: center;
						margin-top: 10px;
						background: linear-gradient(222deg,rgba(255,169,88,1) 0%,rgba(255,105,61,1) 100%);
						border-radius: 25px;
						font-size: 15px;
						font-weight: bold;
						color: #fff;
					}
				}
				.plat-o {
					.btn {
						width: 100%;
						height: 40px;
						line-height: 40px;
						text-align: center;
						background: linear-gradient(222deg,rgba(0,194,255,1) 0%,rgba(60,67,236,1) 100%);
						border-radius: 25px;
						font-size: 15px;
						font-weight: bold;
						color: #fff;
					}
					.prompt {
						margin-top: 10px;
						font-size: 12px;
						color: #999;
						width: 100%;
						text-align: center;
					}
				}
			}
		}
		.info-popup-content {
			width: 100%;
			box-sizing: border-box;
			border-radius: 6px 6px 0px 0px;
			.popup-title {
				width: 100%;
				height: 58px;
				text-align: center;
				line-height: 58px;
				position: relative;
				border-bottom: 1px #ccc solid;
				img {
					position: absolute;
					top: 18px;
					left: 14px;
				}
			}
			.myform {
				width: 100%;
				overflow: hidden;
			}
			.opration {
				width: 100%;
				position: absolute;
				bottom: 20px;
				box-sizing: border-box;
				padding: 0 15px;
				.btn {
					width: 100%;
					height: 40px;
					line-height: 40px;
					text-align: center;
					background: linear-gradient(222deg,rgba(0,194,255,1) 0%,rgba(60,67,236,1) 100%);
					border-radius: 25px;
					font-size: 15px;
					font-weight: bold;
					color: #fff;
				}
				.prompt {
					margin-top: 10px;
					font-size: 12px;
					color: #999;
					width: 100%;
					text-align: center;
				}
			}
		}
	}
</style>
